import { ignoreSharingTip } from '../../actions/internalActions';
import datapoints from '../../datapoints';
import ComposeLinkViewState from '../../store/schema/ComposeLinkViewState';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { logUsage } from 'owa-analytics';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import { InfoBarMessageRank } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { getSharingDataFromLink } from 'owa-link-data';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import {
    getSharingIssuesForSharingData,
    SharingTipId,
    SharingTipRecipientInfo,
} from 'owa-sharing-data';

const styles = require('../../components/LinkContextMenuCustomItems.scss');
const classNames = require('classnames/bind').bind(styles);

export function getSharingTipContextMenuItem(
    composeLinkViewState: ComposeLinkViewState,
    recipientInfo: SharingTipRecipientInfo[]
): IContextualMenuItem | null {
    // We need the flights for sharing tips and contextual sharing tips to show this menu item
    if (
        !isFeatureEnabled('doc-attachment-contextualSharingTips') ||
        !isFeatureEnabled('doc-attachment-sharingTips')
    ) {
        return null;
    }

    const sharingData = getSharingDataFromLink(composeLinkViewState.linkId);
    const sharingIssues = getSharingIssuesForSharingData(sharingData, recipientInfo).filter(
        issue => composeLinkViewState.sharingTipsIgnored.indexOf(issue.id) === -1
    );

    // Only show the menu item if there is a sharing tip that the user has not choosen to ignore
    if (sharingIssues.length > 0) {
        if (sharingIssues.length > 1) {
            logUsage(datapoints.AttachmentLinkMultipleSharingTipsShown.datapoint.name);
        }
        const sharingIssue = sharingIssues[0];
        return {
            key: 'contextualSharingTip',
            onRender: (
                item: any,
                dismissMenu: (ev?: any, dismissAll?: boolean) => void
            ): React.ReactNode => {
                const conditionalStyles = {
                    error: sharingIssue.messageRank === InfoBarMessageRank.Error,
                };
                return (
                    <div
                        className={styles.menuItemContainer}
                        aria-label={sharingIssue.sharingTipString}
                        aria-posinset={1}
                        aria-setsize={7}
                        aria-disabled="false"
                        role="menuitem"
                        onClick={() => {
                            dismissMenu();
                        }}
                        tabIndex={0}>
                        <div className={styles.iconContainer}>
                            <Icon
                                iconName={ControlIcons.Info}
                                className={classNames(styles.sharingTipIcon, conditionalStyles)}
                            />
                        </div>
                        <div className={styles.text}>
                            {sharingIssue.sharingTipString}
                            <button
                                className={styles.ignoreButton}
                                onClick={() => {
                                    ignoreSharingTip(composeLinkViewState.linkId, sharingIssue.id);
                                    logIgnoreSharingTipDatapoint(sharingIssue.id);
                                }}>
                                {strings.SuggestActionIgnoreExpiration}
                            </button>
                        </div>
                    </div>
                );
            },
        };
    }

    return null;
}

function logIgnoreSharingTipDatapoint(sharingTipId: SharingTipId) {
    const {
        name: eventName,
        customData: customData,
    } = datapoints.AttachmentLinkSharingTipIgnored.datapoint;
    logUsage(eventName, customData(sharingTipId));
}
